"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subtitle = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
/**
 * Subtitle for a page layout
 */
exports.Subtitle = styled_components_1.default.h2 `
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  color: ${({ theme }) => theme.designSystem.white};
  text-align: center;
  user-select: none;

  margin: 0;
`;
